export default class Store {
  constructor(key, storage) {
    this._storage = storage;
    this._storeKey = key;
  }

  getItems(type) {
    try {
      return this._storage[type] || {};
    } catch (err) {
      return {};
    }
  }

  getItem(key, type) {
    try {
      return this._storage[type][key] || {};
    } catch (err) {
      return ``;
    }
  }

  setItems(items, type) {
    this._storage.setItem(this._storeKey, items, type);
  }

  setItem(key, value, type) {
    const store = this.getItems(type);

    this._storage[type] = Object.assign({}, store, {
      [key]: value,
    });
  }

  removeItem(key, type) {
    delete this._storage[type][key];
  }
}
